import React from 'react'

import ReactDOM from "react-dom/client"

// 导入PC根组件
import AppPc from "./AppPc"
// 导入Wap根组件
import AppWap from "./AppWap"

// 导入自定义组件
import { isMobile } from "./utils"

// 引入自定义公共样式
import './assets/css/common.scss'

// 渲染组件
if (isMobile() === 'PC') {
    // 渲染PC
    ReactDOM.createRoot(document.getElementById('root')).render(<AppPc />);
} else {
    // 渲染Wap
    ReactDOM.createRoot(document.getElementById('root')).render(<AppWap />);
}
